import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Template } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDuplicateTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (templateData: Partial<Template>) => {
      await request({
        path: `template/add`,
        method: 'POST',
        authenticate: true,
        dataObject: templateData,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-templates'] });
      toast.success('Template duplicated successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error duplicating template!');
    },
  });
};
